
import { defineComponent } from "vue";
import { SandpackConsole, ConsoleIcon } from "codesandbox-sandpack-vue3";
import Loading from "./Loading.vue";
import SandpackNavigation from "./SandpackNavigation.vue";

export default defineComponent({
  name: "SandpackReact",
  props: {
    codeMap: Object as any,
    frame: String,
  },
  components: {
    SandpackConsole,
    SandpackNavigation,
    Loading,
    ConsoleIcon,
  },
  emits: [],
  data() {
    return {
      loading: true,
      consoleVisible: true,
      frameMap: {
        react: "/src/Pano/index.tsx",
        vue3: "/src/Pano.vue",
      },
    };
  },
  watch: {},
  computed: {
    files(): Object {
      if (this.frame === "react") {
        return {
          "/src/Pano/index.tsx": {
            code: this.codeMap?.codeString,
            active: true,
          },
        };
      } else {
        return {
          "/src/Pano.vue": {
            code: this.codeMap?.codeString,
            active: true,
          },
        };
      }
    },
  },
  methods: {
    getLoading(loading: boolean) {
      this.loading = loading;
    },
    switchConsole() {
      this.consoleVisible = !this.consoleVisible;
    },
  },
});
